<template>
  <span :class="$style.icon" aria-hidden="true">
    <component :is="component" :class="$style.asset" />
  </span>
</template>

<script lang="ts" setup>
import {
  type FunctionalComponent,
  type SVGAttributes,
  computed,
  defineAsyncComponent
} from 'vue'
import { useConfig } from '@/ui-core/composables/use-config'

type IconComponent = FunctionalComponent<SVGAttributes>

defineOptions({
  name: 'UiIcon'
})

const props = defineProps<{
  name: string
}>()

const { config } = useConfig()

const component = computed(() => {
  const { name } = props
  const { iconImportObject } = config.value

  const [, importFunc] =
    Object.entries(iconImportObject).find(([key]) =>
      key.endsWith(`/${name}.svg`)
    ) ?? []

  return defineAsyncComponent<IconComponent>(
    () => importFunc?.() ?? import(`./assets/${name}.svg`)
  )
})
</script>

<style lang="scss" module>
.icon {
  display: inline-flex;
}

.asset {
  width: 100%;
  height: 100%;
}
</style>
